import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ArtefactManagementService } from './api/artefactManagement.service';
import { EntityService } from './api/entity.service';
import { HelpService } from './api/help.service';
import { LogService } from './api/log.service';
import { MailService } from './api/mail.service';
import { NoteService } from './api/note.service';
import { ProductService } from './api/product.service';
import { SubscriptionService } from './api/subscription.service';
import { SubscriptionCancelService } from './api/subscriptionCancel.service';
import { TagService } from './api/tag.service';
import { TextService } from './api/text.service';
import { VersionService } from './api/version.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ArtefactManagementService,
    EntityService,
    HelpService,
    LogService,
    MailService,
    NoteService,
    ProductService,
    SubscriptionService,
    SubscriptionCancelService,
    TagService,
    TextService,
    VersionService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
